import { render, staticRenderFns } from "./BookDetail.vue?vue&type=template&id=4774e19e&scoped=true&"
import script from "./BookDetail.vue?vue&type=script&lang=js&"
export * from "./BookDetail.vue?vue&type=script&lang=js&"
import style0 from "./BookDetail.vue?vue&type=style&index=0&id=4774e19e&prod&scoped=true&lang=scss&"
import style1 from "./BookDetail.vue?vue&type=style&index=1&id=4774e19e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4774e19e",
  null
  
)

export default component.exports